document.addEventListener('DOMContentLoaded', () => {
    let questions = document.querySelectorAll('section.faq .qa-pair');
    let answers = document.querySelectorAll('section.faq .qa-pair .answer');

    if (questions && answers) {
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.contentBoxSize) {
                    // Firefox implements `contentBoxSize` as a single content rect, rather than an array
                    const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
                    entry.target.setAttribute('style', `--open-height: ${entry.target.scrollHeight}px;`);
                } else {
                    entry.target.setAttribute('style', `--open-height: ${entry.target.scrollHeight}px;`);
                }
            }
        });

        for (let i = 0; i < questions.length; i++) {
            answers[i].setAttribute('style', `--open-height: ${answers[i].scrollHeight}px;`);
            resizeObserver.observe(answers[i]);

            questions[i].addEventListener('click', (e) => {
                if (e.target.tagName == 'A') {
                    return;
                }

                if (!questions[i].classList.contains('open')) {
                    document.querySelector('section.faq .qa-pair.open')?.classList.toggle('open');
                }
                
                questions[i].classList.toggle('open');
            });
        }
    }
});